import _ from 'lodash';
import { instBundle } from '@/axios.js';
const axios = instBundle.axios;

const state = {
	selection: {
		category1st: null,
		category2nd: null,
		category3rd: null,
		depth: null,
		id: null,
		adding: {},
	},
	modified: {
		category1stOrder: false,
		category2ndOrder: false,
		category3rdOrder: false,
	},
	category1st: [],
	category2nd: [],
	category3rd: [],
	searchKeywords: [],
	reviewKeywords: [],
};

const mutations = {
	setCategory(state, { selection, data }) {
		data = _.each(data, item => {
			if (!item.keyword) {
				item.keyword = '';
			}
		});
		state[selection] = data;
	},
	setReviewKeywords(state, { data }) {
		const keywordsLength = data.keywords.length;

		if (keywordsLength < 5) {
			for (let i = 0; i < 5 - keywordsLength; i++) {
				data.keywords.push({
					keyword: '',
					words: [],
				});
			}
		}
		state.reviewKeywords = data;
	},
	refreshReviewKeywords(state, { values }) {
		const target = _.find(state[state.selection.depth], {
			id: state.selection.id,
		});
		const keywords = [];

		_.each(values, value => {
			keywords.push(value.keyword);
		});

		target.reviewKeyword = keywords.join(',');
		target.reviewKeywordArray = keywords;
	},
	changeSelection(state, { depth, id, subCategories }) {
		state.selection.depth = depth;
		state.selection.id = id;

		if (depth === 'category1st') {
			state.selection.category1st = id;
			state.selection.category2nd = null;
			state.selection.category3rd = null;

			state.modified.category2ndOrder = false;
			state.modified.category3rdOrder = false;

			state.category2nd = subCategories;
			state.category3rd = [];
		} else if (depth === 'category2nd') {
			const category2nd = _.find(state.category2nd, { id });

			state.selection.category2nd = id;
			state.selection.category3rd = null;

			state.modified.category3rdOrder = false;

			if (category2nd.showMergedChildren && !!subCategories) {
				subCategories.unshift({
					id: 'entire',
					name: '전체',
					productCount: category2nd.productCount,
					sortKey: 0,
				});
			}

			state.category3rd = subCategories;
		} else {
			state.selection.category3rd = id;
		}
	},
	orderChange(state, { selection, currentId, prevOrNextId }) {
		const current = _.find(state[selection], { id: currentId });
		const prevOrNext = _.find(state[selection], { id: prevOrNextId });
		[current.sortKey, prevOrNext.sortKey] = [
			prevOrNext.sortKey,
			current.sortKey,
		];

		state.modified[`${selection}Order`] = true;
	},
	orderChanged(state, { selection }) {
		state.modified[`${selection}Order`] = false;
	},
	changeIsDisplay(state, { value }) {
		const target = _.find(state[state.selection.depth], {
			id: state.selection.id,
		});
		target.isDisplay = value;
	},
	changeIsNew(state, { value }) {
		const target = _.find(state[state.selection.depth], {
			id: state.selection.id,
		});
		target.isNew = value;
	},
	changeShowEntireCategories(state, { value }) {
		const target = _.find(state[state.selection.depth], {
			id: state.selection.id,
		});

		target.showMergedChildren = value;
	},
	changeNames(state, { longName, shortName, shortWording }) {
		const target = _.find(state[state.selection.depth], {
			id: state.selection.id,
		});
		target.name = longName;
		target.shortText = shortName;
		target.shortWording = shortWording;
	},
	setImage(state, { value, ext, name }) {
		const target = _.find(state[state.selection.depth], {
			id: state.selection.id,
		});

		target.image = value;
		target.imageExt = ext;
		target.imageName = name;
	},
	setBackImage(state, { value, ext, name }) {
		const target = _.find(state[state.selection.depth], {
			id: state.selection.id,
		});

		target.backImage = value;
		target.backImageExt = ext;
		target.backImageName = name;
	},
	setSearchKeyword(state, { data }) {
		state.searchKeywords = data;
	},
	refreshSearchKeywords(state, { value }) {
		const target = _.find(state[state.selection.depth], {
			id: state.selection.id,
		});

		target.keyword = value;
	},
	refreshDalphaKeywords(state, { value }) {
		const target = _.find(state[state.selection.depth], {
			id: state.selection.id,
		});

		target.dalphaKeyword = value;
	},
	setAddingStatus(state, { depth, parentId }) {
		state.selection.adding.depth = depth;
		state.selection.adding.level = {
			category1st: 1,
			category2nd: 2,
			category3rd: 3,
		}[depth];
		state.selection.adding.parentId = parentId;
	},
	deleteCategory(state) {
		const targetIndex = _.findIndex(state[state.selection.depth], {
			id: state.selection.id,
		});

		state[state.selection.depth].splice(targetIndex, 1);

		if (state.selection.depth === 'category1st') {
			state.category2nd = [];
			state.category3rd = [];

			state.selection.category1st = null;
			state.selection.category2nd = null;
			state.selection.category3rd = null;
		} else if (state.selection.depth === 'category2nd') {
			state.category3rd = [];

			state.selection.category2nd = null;
			state.selection.category3rd = null;
		} else if (state.selection.depth === 'category3rd') {
			state.selection.category3rd = null;
		}
	},
	updateCategory3rd(state, current) {
		const targetIndex = _.findIndex(state.category3rd, { id: 'entire' });

		if (current.showMergedChildren) {
			if (targetIndex === -1) {
				state.category3rd.unshift({
					id: 'entire',
					name: '전체',
					productCount: current.productCount,
					sortKey: 0,
				});
			}
		} else {
			state.category3rd.splice(targetIndex, 1);
		}
	},
};

const getters = {
	getCategory1st(state) {
		return _.orderBy(state.category1st, ['sortKey']);
	},
	getCategory2nd(state) {
		return _.orderBy(state.category2nd, ['sortKey']);
	},
	getCategory3rd(state) {
		return _.orderBy(state.category3rd, ['sortKey']);
	},
	getSelectedCategoryNames(state) {
		const category1st = _.find(state.category1st, {
			id: state.selection.category1st,
		});
		const category2nd = _.find(state.category2nd, {
			id: state.selection.category2nd,
		});
		const category3rd = _.find(state.category3rd, {
			id: state.selection.category3rd,
		});

		const names = [];
		!!category1st ? names.push(category1st.name) : null;
		!!category2nd ? names.push(category2nd.name) : null;
		!!category3rd ? names.push(category3rd.name) : null;

		return names;
	},
	getCurrentSelected(state) {
		if (state.selection.depth === null || state.selection.id === null) {
			return {};
		}

		const info = _.find(state[state.selection.depth], {
			id: state.selection.id,
		});

		if (!info) {
			return {};
		}

		if (info.hasOwnProperty('keyword')) {
			if (!!info.keyword) {
				info.searchKeywordsArray = info.keyword.split(',');
			} else {
				info.searchKeywordsArray = '';
			}
		}

		if (
			info.hasOwnProperty('reviewKeyword') &&
			info.reviewKeyword.length > 0
		) {
			info.reviewKeywordArray = info.reviewKeyword.split(',');
		} else {
			info.reviewKeywordArray = [];
			info.isReviewKeyword = false;
		}

		info.depth = state.selection.depth;
		info.level = {
			category1st: 1,
			category2nd: 2,
			category3rd: 3,
		}[info.depth];

		return info;
	},
	getReviewKeywords(state) {
		return state.reviewKeywords;
	},
	getIsReviewKeyword(state) {
		const target = _.find(state[state.selection.depth], {
			id: state.selection.id,
		});

		if (!!target) {
			return target.isReviewKeyword;
		} else {
			return false;
		}
	},
	isCategoryNameDuplicate: state => (name, depth) => {
		let targetDepth;

		if (typeof depth === 'undefined') {
			targetDepth = state.selection.depth;
		} else {
			targetDepth = depth;
		}

		const target = _.find(state[targetDepth], { name: name.trim() });

		return !!target && target.id !== state.selection.id;
	},
};

const actions = {
	saveOrderChange({ commit, state }) {
		return new Promise((resolve, reject) => {
			const orderedId = [];

			_.each(
				_.orderBy(state[state.selection.depth], ['sortKey']),
				category => {
					if (category.id !== 'entire') {
						orderedId.push({
							idCategory: category.id,
							sortKey: category.sortKey,
						});
					}
				}
			);

			resolve(orderedId);
		});
	},
	changeIsReviewKeyword({ commit, state }, onlyData = false) {
		return new Promise(async (resolve, reject) => {
			const target = _.find(state[state.selection.depth], {
				id: state.selection.id,
			});

			if (onlyData) {
				target.isReviewKeyword = false;

				resolve(false);
				return;
			}

			if (!target.isReviewKeyword) {
				const response = await axios.get(
					`/lambda/admin/category/reviewKeyword/${state.selection.id}`
				);

				if (response.data.keywords.length < 5) {
					alert('키워드 5개를 모두 등록해주세요');
					target.isReviewKeyword = false;

					resolve(false);
					return;
				}

				let isActive = true;
				_.each(response.data.keywords, keyword => {
					if (
						_.filter(keyword.words, { isActive: true }).length === 0
					) {
						isActive = false;
					}
				});

				if (!isActive) {
					alert('키워드별 연관단어를 1개 이상 활성화시켜주세요');
					target.isReviewKeyword = false;
					resolve(false);
					return;
				}

				target.isReviewKeyword = true;
				resolve(true);
			} else {
				target.isReviewKeyword = false;
				resolve(false);
			}
		});
	},
};

export default {
	namespaced: true,
	state,
	mutations,
	getters,
	actions,
};
